export class WidgetProps {
    continueInitialization = true;

    /*without this the class should not be initiated at all*/
    container = null;

    selectors = {};

    elements = {};

    constructor(container) {
        this.container = container;
    }
}

export default class BaseWidget {
    props;

    constructor(container) {
        this.props = this.getPropsInstance(container);
        this.init();
    }

    init() {}

    setElements() {}

    addListeners() {}

    getPropsInstance(container) {
        return new WidgetProps(container);
    }

    getElementsArray(selector, element = document) {
        return [...element.querySelectorAll(selector)];
    }
}
